// Copyright (c) StrangeBee 2024

import { CustomFieldInput, CustomFieldController } from 'thehive-sdk';

interface CustomFieldEditValues extends CustomFieldInput {
    customFieldId?: string;
}

interface EventListParams {
    locale: (label: string) => string;
    controller: CustomFieldController;
    onSuccess: (message?: string) => void;
    onError: (label?: string) => void;
}

export interface EventListOutput {
    onCreate: (value: CustomFieldInput) => void;
    onEdit: ({ customFieldId, ...rest }: Partial<CustomFieldEditValues>) => Promise<void>;
    onDelete: (customFieldId: string, force?: boolean) => void;
}

export const computeEventList = ({ controller, locale, onSuccess, onError }: EventListParams): EventListOutput => ({
    onCreate: (value: CustomFieldInput): void => {
        controller
            .create(value)
            .then(() => {
                onSuccess(locale('notification.customField.create'));
            })
            .catch(onError);
    },
    onEdit: ({ customFieldId, ...rest }) =>
        controller
            .edit(rest, customFieldId)
            .then(() => onSuccess(locale('notification.customField.edit')))
            .catch(onError),
    onDelete: (customFieldId, force): void => {
        controller
            .deleteCustomField(customFieldId, force)
            .then(() => {
                onSuccess(locale('notification.customField.delete'));
            })
            .catch(onError);
    },
});
